import React from 'react';
import classNames from 'classnames';
import { Rate as AntdRate } from 'antd';
import { ConfigContext } from '../config-provider';
import AntdConfigProvider from 'antd/es/config-provider';
const Rate = React.forwardRef(({ prefixCls, ...props }, ref) => {
    const { size, className, ...otherProps } = props;
    const { getPrefixCls, ...restContext } = React.useContext(ConfigContext);
    const classPrefix = getPrefixCls('rate', prefixCls);
    const newClassName = classNames({
        [`${classPrefix}-sm`]: size === 'small',
        [`${classPrefix}-lg`]: size === 'large'
    }, className);
    return (React.createElement(AntdConfigProvider, { prefixCls: getPrefixCls('', prefixCls), ...restContext },
        React.createElement(AntdRate, { className: newClassName, ...otherProps, ref: ref, prefixCls: classPrefix })));
});
Rate.defaultProps = {
    size: 'middle'
};
// const ConfiguredRate = withConfigProvider(Rate);
// export { ConfiguredRate as Rate };
// export default ConfiguredRate;
export default Rate;
